<template>
    <div>
        <div class="flex flex-col flex-wrap">
            <div
                class="border p-2 w-full overflow-auto flex flex-row justify-between 
        items-center bg-white hover:bg-gray-200 transition-colors duration-300"
                :class="{ 'bg-secondary-pastel text-black hover:bg-gray-200 hover:text-black': rowIndex % 2 === 0 }"
            >
                <h2 class="text-lg font-medium text-light-grey">{{ externalCourse.external_course_title }}</h2>
                <ul class="text-primary icon-row">
                    <li v-if="certificateAllowed" class="icon-list-item">
                        <external-course-certificate
                            :external-course-user-id="externalCourse.external_course_user_id"
                            class="icon-wrapper"
                        ></external-course-certificate>
                    </li>
                    <li :title="statusText" class="icon-list-item">
                        <div class="icon-wrapper">
                            <component class="h-6" :is="statusIconComponentName" />
                        </div>
                    </li>
                    <li v-if="score" class="text-xs text-center">{{ statusText }}<br />{{ dateFinished }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import slugify from "slugify";
import ExternalCourseMixin from "@/components/courses/ExternalCourseMixin";

export default {
    name: "ExternalCourseRow",
    mixins: [ExternalCourseMixin],
    props: {
        externalCourse: {
            type: Object,
            required: true
        },
        rowIndex: {
            type: Number,
            required: true
        }
    },
    methods: {
        slugify(title) {
            return slugify(title, { lower: true, strict: true, locale: "en" });
        }
    }
};
</script>
